import { useCallback } from 'react'

import { useAppDispatch } from '@app/utils/redux'

import type { ThunkAction } from '@app/store/thunk'

type BoundActionCreator<T extends (...args: any[]) => ThunkAction<any>> = (...args: Parameters<T>) => ReturnType<ReturnType<T>>

export const useAction = <Action extends (...args: any[]) => ThunkAction<unknown>>(action: Action): BoundActionCreator<Action> => {
  const dispatch = useAppDispatch()

  return useCallback<BoundActionCreator<Action>>((...args) => dispatch(action(...args)) as any, [dispatch, action])
}
